// Client half of the SMS consent confirmation gate. The record lives in the API (trackable-api
// TRK-5807); this decides WHEN to ask, so the modal opens before anything is saved.
//
// The client asks before ANY texting workflow goes live, as the legal spec requires. The API is
// narrower today: it refuses only form-triggered ones (form_created, form_updated,
// form_date_reached). Until it is widened to match, the server enforces the form case and this
// is the only check on the rest.
import type { WorkflowNode } from 'app/types/workflows'

/** Shown when the modal is dismissed on a path that was turning texting on. */
export const SMS_CONSENT_CANCELLED_MESSAGE = `Texting wasn't turned on. You can publish once you've confirmed consent.`

// Every canvas step that results in an outbound text. An AI agent handoff opens with a real SMS.
// Mirrors the API's list of texting steps; a new one belongs in both.
const SMS_SENDING_KINDS: ReadonlySet<string> = new Set([`sendSms`, `aiAgentSms`])

/** True when turning the workflow on needs the workspace's consent confirmation. */
export function sendsSms(nodes: Pick<WorkflowNode, `type`>[]): boolean {
  return nodes.some((node) => !!node.type && SMS_SENDING_KINDS.has(node.type))
}

// The API's refusal is a bare GraphQLError with no extensions.code, so the message is the only
// signal. It reads "This workspace has not confirmed texting consent. Confirm consent before
// activating a form-triggered texting workflow." Matched loosely so a wording tweak on the API
// side does not silently turn the modal off.
export function isSmsConsentRefusal(message: string | undefined): boolean {
  return !!message && /confirm(ed)? (texting )?consent/i.test(message)
}
